import tippy from 'tippy.js'

/**
 * @type variable
 * @description Used to check if the current environment is a production environment.
 */
export const isProduction = process.env.NODE_ENV === 'production'

/**
 * @type array
 * @description Used to get the screen breakpoints.
 */
export const breakpoints = {
  phoneXS: 0,
  phoneSM: 321,
  phoneMD: 426,
  tablet: 576,
  desktopXS: 775,
  desktopS: 992,
  desktopM: 1200,
  desktopL: 1280,
  desktopXL: 1367,
  desktopXXL: 1740,
  desktopUltrawide: 2000,
}

/**
 * @type interface
 * @description Here we are extending the Window interface with the grecaptcha property.
 */
declare let grecaptcha: any

/**
 * @type Function
 * @description This is a companion function that is used in "handleRecaptcha", can also be used as a standalone.
 * @returns A boolean value that indicates if the recaptcha is valid or not.
 * @example if (validateRecaptcha()) { // Do something }
 */
export function validateRecaptcha(): boolean {
  const v = grecaptcha.getResponse()

  if (v.length === 0) {
    return false
  }

  return true
}

/**
 * @type Function
 * @param  {Event} event
 * @param  {HTMLElement} element
 * @description This is the function that is used to validate the recaptcha and handles the error message as well.
 * @return void. It will prevent the default event if the recaptcha is not valid.
 * @example handleRecaptcha(event, element)
 */

export function handleRecaptcha(event: Event, element: HTMLElement): void {
  if (element) {
    if (!element.classList.contains('hide')) {
      element.classList.add('hide')
    }

    if (!validateRecaptcha()) {
      event.preventDefault()
      element.classList.remove('hide')
    }
  }
}

let timerId
export function debounce(func, delay = 500) {
  return (...args) => {
    clearTimeout(timerId)
    timerId = setTimeout(() => {
      func(...args)
    }, delay)
  }
}

export function formatNumber(number) {
  //!don't use this function, use formatCurrency instead
  const formatedNumber = number
    .toString()
    .replace(/\D/g, '')
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.')

  return formatedNumber
}

export function validateRecaptcha3(form: HTMLElement): void {
  const key = <HTMLDivElement>form.querySelector('.g-recaptcha')
  const recaptchaElement = <HTMLInputElement>document.getElementsByName('g-recaptcha-response')[0]

  if (recaptchaElement != null) {
    // e.preventDefault()
    grecaptcha.ready(() => {
      // do request for recaptcha token
      // response is promise with passed token

      grecaptcha.execute(key.getAttribute('data-siteKey'), { action: 'validate_captcha' }).then(function (token) {
        // add token value to form
        recaptchaElement.value = token
      })
    })
  }
}

export function initTooltip(element): void {
  tippy(element, {
    arrow: true,
    animation: 'fade',
    theme: 'blue',
    duration: 500,
  })
}
